// Mouse click-drag scrolling for desktop.
// Touch/swipe works natively via CSS scroll-snap — no JS needed there.
document.querySelectorAll( '[data-carousel-id]' ).forEach( ( carousel ) => {
	let startX = 0;
	let scrollLeftStart = 0;
	let isDown = false;
	let isDragging = false;

	carousel.addEventListener( 'mousedown', ( e ) => {
		isDown = true;
		isDragging = false;
		startX = e.clientX;
		scrollLeftStart = carousel.scrollLeft;
	} );

	document.addEventListener( 'mousemove', ( e ) => {
		if ( ! isDown ) return;
		const dx = e.clientX - startX;
		if ( Math.abs( dx ) > 5 ) {
			isDragging = true;
			carousel.classList.add( 'is-dragging' );
			carousel.scrollLeft = scrollLeftStart - dx * 1.5;
		}
	} );

	document.addEventListener( 'mouseup', () => {
		if ( ! isDown ) return;
		isDown = false;
		carousel.classList.remove( 'is-dragging' );
		// Reset after click fires (click fires synchronously after mouseup)
		setTimeout( () => { isDragging = false; }, 0 );
	} );

	// Suppress the click that fires after a drag so links don't activate
	carousel.addEventListener( 'click', ( e ) => {
		if ( isDragging ) {
			e.preventDefault();
			e.stopPropagation();
		}
	}, true );

	// Navigation dots
	if ( carousel.dataset.showDots !== 'true' ) return;

	const slides = Array.from( carousel.children ).filter(
		( el ) => el.classList.contains( 'wp-block-group' )
	);

	if ( slides.length < 2 ) return;

	const dotsWrapper = document.createElement( 'div' );
	dotsWrapper.className = 'aya-scroll-carousel__dots';

	const dots = slides.map( ( slide, i ) => {
		const dot = document.createElement( 'button' );
		dot.className = 'aya-scroll-carousel__dot';
		dot.setAttribute( 'aria-label', `Go to slide ${ i + 1 }` );
		if ( i === 0 ) dot.classList.add( 'is-active' );

		dot.addEventListener( 'click', () => {
			// Scroll within this carousel instance only — avoids page scroll side-effects.
			carousel.scrollLeft = slide.offsetLeft;
		} );

		dotsWrapper.appendChild( dot );
		return dot;
	} );

	carousel.after( dotsWrapper );

	// Update active dot as slides enter the viewport
	const observer = new IntersectionObserver(
		( entries ) => {
			entries.forEach( ( entry ) => {
				if ( entry.isIntersecting ) {
					const index = slides.indexOf( entry.target );
					dots.forEach( ( d, i ) => d.classList.toggle( 'is-active', i === index ) );
				}
			} );
		},
		{ root: carousel, threshold: 0.5 }
	);

	slides.forEach( ( slide ) => observer.observe( slide ) );
} );
